import {SurveyCheckGreen} from '@jobseeker/lotus/assets/icons';
import {Box, Typography, Zoom} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';

type SuccessPanelProps = {
  title: string;
  subtitle: string;
  children?: React.ReactNode;
  icon?: string;
};

const SuccessPanel = ({
  title,
  subtitle,
  children,
  icon = SurveyCheckGreen,
}: SuccessPanelProps) => {
  return (
    <Box textAlign={'center'} py={12.5} px={1}>
      <Zoom in={true}>
        <Box>
          <Image src={icon} width={48} height={48} alt="successIcon" />
        </Box>
      </Zoom>
      <Typography fontSize={18} fontWeight={500}>
        {title}
      </Typography>
      <Typography variant="subtitle2" color="text.secondary">
        {subtitle}
      </Typography>
      {children}
    </Box>
  );
};

export default SuccessPanel;
